import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function CursorConnectionForm({ onSubmit, guideMode }) {
  const [showSecret, setShowSecret] = useState(false);
  const handleClickShowSecret = () => setShowSecret((prev) => !prev);
  const handleMouseDownSecret = (event) => event.preventDefault();

  const formInitialValues = {
    admin_api_key: "",
  };

  const formCheckoutSchema = yup.object().shape({
    admin_api_key: yup.string().required("required"),
  });

  const handleFormSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                type={showSecret ? "text" : "password"}
                name="admin_api_key"
                label="Admin API Key"
                value={values.admin_api_key}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.admin_api_key && !!errors.admin_api_key}
                helperText={touched.admin_api_key && errors.admin_api_key}
                autoComplete="off"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle secret visibility"
                        onClick={handleClickShowSecret}
                        onMouseDown={handleMouseDownSecret}
                      >
                        {showSecret ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={guideMode}
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
